import { render } from "./Hello.vue?vue&type=template&id=6cbe5837"
import script from "./Hello.vue?vue&type=script&lang=js"
export * from "./Hello.vue?vue&type=script&lang=js"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__